<script>
    // import angebote from './angebote.svelte';
    export let angebote; 
    import { fade } from 'svelte/transition';
    // import axios from "axios";
    // import { onMount } from "svelte";
    import Bgg_link from "./Bgg_link.svelte"
    import Preis from "./Preis.svelte"
	// import { storeFE } from './store.js';
    let result = null;
    const deleteThisTask = () => {
        TasksCollection.remove(task._id);
    };


    function onDelete(id) {
   
        console.log(JSON.stringify({"productid":id }));
        angebote = angebote.filter(ob => !id.includes(ob.productid))
        const api_delete = "https://spiele.ulrichlang.de/read.php";
        async function write_to_offers_read (id) {
            var data = new FormData();
            data.append("productid:",encodeURIComponent(id) );
    		const res = await fetch(api_delete, {
			method: 'POST',
            body: JSON.stringify({"productid":id }),
            
		});
	}
    write_to_offers_read(id);
}

</script>
<main class="angebote">

      <!--Falls Angebote vorliegen rendere die Angebote-->
  {#if angebote}
  {#each angebote as angebot}
 


<div class = "angebot" in:fade="{{duration: 1000 }}" out:fade>
    
    <Bgg_link {angebot} /> 
        <Preis {angebot} />
    
        <div>
          
            <h4>{angebot.name}</h4> 
            
        </div>
        {#if angebot.version !== null}
            <p >{angebot.version}</p>
        {/if}
        
        {#if angebot.notes !== null}
            <p>{angebot.notes}</p>
        {/if}

        {#if angebot.marktpreis !== null}
        <p>Marktpreis: {angebot.marktpreis} €</p>
        {/if}


        
            {#if angebot.actual_price}
            <p>Neupreis:  
                {angebot.actual_price} €</p>
            {:else}<p>Momentan nicht verfügbar. </p>
            {/if} 
            
            <p><button class="delete" on:click={onDelete(angebot.productid)}>gelesen</button></p>
 
</div>
{/each}
{/if}

</main>



<style>
    p{
    text-align: left;
    font-size: small;
    /* margin: 0; */
}
    h4{font-size: x-large;
        font-weight: lighter;
        text-align: center;
    margin: 0;}

.angebote{
display: flex;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  background: #E7F3F1;
  border: .75em solid white;
  padding: 1em;
  font-family: 'Open Sans', sans-serif;
  flex-wrap: wrap;
}
.angebot {
    display: flex;
  flex-wrap: wrap;
 border-bottom: black 1px solid;
 margin-bottom: 0.3em;
 border-radius: 2px;
height:25em;

  max-width: 10.75em;
  min-height: 20.75em;
  overflow: auto;
  border-radius: .5em;
  text-decoration: none;
  background: white;
  margin: 1em;
  padding: 2.75em 2.5em;
  box-shadow: 0 1.5em 2.5em -.5em rgba(#000000, .1);
  transition: transform .45s ease, background .45s ease;
}


.delete{height: 2em;
    border: none;
background-color: #50bfbf;
}
.delete:hover{
    opacity: 0.3;
}

@media only screen 
and (min-device-width : 375px) 
and (max-device-width : 667px) {

.angebote {
    display:flex;
    min-height:100vh;
    align-items:center;
    justify-content:center;
    background:#E7F3F1;
    border:.75em solid white;
    font-family:'Open Sans', sans-serif;
    flex-wrap:wrap;
padding: 0;
}

}
</style>

<!-- markup (zero or more items) goes here -->